import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SuccessResponse } from 'src/app/common/models/SuccessRespons';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';
import { environment as env } from 'src/environments/environment';
import { tap } from 'rxjs';
import { DataManagerService } from './data-manager.service';

@Injectable({ providedIn: 'root' })
export class SecurityService {
  private BASE_URL = `${env.PROPERTYBR_API_BASE_URL}/security`;

  constructor(
    private httpClient: HttpClient,
    private localStorageService: LocalStorageService,
    private dataManagerService: DataManagerService
  ) {}

  logout() {
    this.notifyLogoutDatadog();
    const token = this.localStorageService.get('sessionToken');
    const URL = `${this.BASE_URL}/logout`;
    return this.httpClient.post<SuccessResponse>(URL, { token });
  }

  refreshToken(captchaToken: string, loginCode: string) {
    const URL = `${this.BASE_URL}/refresh-token`;

    return this.httpClient.post<SuccessResponse>(URL, { captchaToken, code: loginCode }).pipe(
      tap(({ result }) => {
        this.localStorageService.set('sessionToken', result.token);
        this.localStorageService.set('sessionExpireIn', result.expireIn);
      })
    );
  }

  removeStorageSession() {
    this.dataManagerService.setQuote();
    this.localStorageService.remove('currentQuote');
    this.localStorageService.remove('planSelected');
    this.localStorageService.remove('sessionToken');
    this.localStorageService.remove('sessionExpireIn');
    this.localStorageService.remove('steps');
    this.localStorageService.remove('brokerSessionInfo');
    this.localStorageService.remove('userGroups');
  }

  notifyLogoutDatadog(): void {
    return (window as any).DD_RUM && (window as any).DD_RUM.clearUser();
  }
}
